"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TranslationKey = void 0;
/* istanbul ignore file */
/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */
let TranslationKey = exports.TranslationKey = /*#__PURE__*/function (TranslationKey) {
  TranslationKey["allBrands"] = "allBrands";
  TranslationKey["articles"] = "articles";
  TranslationKey["brands"] = "brands";
  TranslationKey["callToActionCatalogueText"] = "callToActionCatalogueText";
  TranslationKey["change"] = "change";
  TranslationKey["clearSearchInput"] = "clearSearchInput";
  TranslationKey["failedToSubmit"] = "failedToSubmit";
  TranslationKey["favorites"] = "favorites";
  TranslationKey["favouriteLists"] = "favouriteLists";
  TranslationKey["gotIt"] = "gotIt";
  TranslationKey["loading"] = "loading";
  TranslationKey["logIn"] = "logIn";
  TranslationKey["loggedInAs"] = "loggedInAs";
  TranslationKey["menu"] = "menu";
  TranslationKey["myAccount"] = "myAccount";
  TranslationKey["myFavoriteProducts"] = "myFavoriteProducts";
  TranslationKey["nextCatalogue"] = "nextCatalogue";
  TranslationKey["noOptions"] = "noOptions";
  TranslationKey["notifications"] = "notifications";
  TranslationKey["open"] = "open";
  TranslationKey["oriflameSweden"] = "oriflameSweden";
  TranslationKey["other"] = "other";
  TranslationKey["popularProducts"] = "popularProducts";
  TranslationKey["popularProductsInThisSearchQuery"] = "popularProductsInThisSearchQuery";
  TranslationKey["popularSearchQueries"] = "popularSearchQueries";
  TranslationKey["products"] = "products";
  TranslationKey["quickBuy"] = "quickBuy";
  TranslationKey["register"] = "register";
  TranslationKey["search"] = "search";
  TranslationKey["searchDesktop"] = "searchDesktop";
  TranslationKey["seeAll"] = "seeAll";
  TranslationKey["seeAllCatalogues"] = "seeAllCatalogues";
  TranslationKey["seeAllResultsFor"] = "seeAllResultsFor";
  TranslationKey["shopFor"] = "shopFor";
  TranslationKey["shoppingBag"] = "shoppingBag";
  TranslationKey["signIn"] = "signIn";
  TranslationKey["topAreaBannerDialogFallbackMessage"] = "topAreaBannerDialogFallbackMessage";
  TranslationKey["topAreaBannerDialogFallbackTitle"] = "topAreaBannerDialogFallbackTitle";
  TranslationKey["topAreaBannerReferralMessage"] = "topAreaBannerReferralMessage";
  TranslationKey["view"] = "view";
  return TranslationKey;
}({});
//# sourceMappingURL=TranslationKey.js.map